export async function fetchOrderInfos() {
  const URL_ELEMENT = document.querySelector('[data-fetch-from]');
  if (!URL_ELEMENT) return;
  const API_URL = URL_ELEMENT.getAttribute('data-fetch-from');

  const FETCH_DATA = await fetch(API_URL, {
    method: "POST",
    headers: {
      Authorization: "Basic " + btoa('api@farnschlaeder.de' + ":" + 'RTU1jeu0yfp3xyk_mfw'),
      "Content-Type": "application/json",
      Accept: "application/json",
    },

    body: JSON.stringify({
      select: {
        orderNumbers: {
          query: `site.index(false).findBy('intendedTemplate', 'order')`,
          select: {
            lastGivenOrderNumber: 'page.last_given_ordernumber',
          }
        }
      }
    })
  })

  return await FETCH_DATA.json();
}
